<template>
    <div class="main-container">
      <acca-modal @modalClosed="isInfoShown = false" class="col-start-4 col-end-9" v-if="isInfoShown">
        <span v-html="selectedText"></span>
      </acca-modal>

      <inner-navigation v-if='userProfile.allowsEdit' class="grid-order-1" link="stats/finance" title="Finans" imgURL="finance-stats.png" navStyle=1></inner-navigation>
      <inner-navigation v-if='userProfile.allowsEdit' class="grid-order-2" link="stats/projects" title="Proje Verileri" imgURL="project-stats.png" navStyle=1></inner-navigation>
        <inner-navigation v-if='userProfile.allowsEdit' class="grid-order-3" link="stats/yearly" title="Yıllara Göre Veriler" imgURL="finance-stats.png" navStyle=1></inner-navigation>
        <external-navigation v-if='userProfile.allowsEdit' hasInfo @infoClicked="showAdditionalInformation('fintex')" class="grid-order-4" href="https://dashboard.fintex.com.tr/" title="Fintex Dashboard Giriş" imgURL="finance-stats.png"></external-navigation>
        <inner-navigation v-if='userProfile.allowsEdit' class="grid-order-1" link="stats/finance-2022" title="2022 Finans Verileri" imgURL="finance-stats.png" navStyle=1></inner-navigation>
        <inner-navigation v-if='userProfile.allowsEdit' class="grid-order-2" link="stats/finance-2023" title="2023 Finans Verileri" imgURL="finance-stats.png" navStyle=1></inner-navigation>
        <inner-navigation v-if='userProfile.allowsEdit' class="grid-order-3" link="stats/finance-2024" title="2024 Finans Verileri" imgURL="finance-stats.png" navStyle=1></inner-navigation>
        <inner-navigation v-if='userProfile.allowsEdit' class="grid-order-4" link="stats/finance-2025" title="2025 Finans Verileri" imgURL="finance-stats.png" navStyle=1></inner-navigation>
    </div>
</template>

<script>

import InnerNavigation from "../InnerNavigation.vue"
import ExternalNavigation from "../ExternalNavigation.vue"
import accaModal from "../reusable/accaModal.vue"
import { mapGetters } from 'vuex'

export default {
  name: 'StatsHome',
  data(){
    return {
      isInfoShown: false,
      selectedText: "",
      additionalInformation: {
        fintex: "<strong>Kullanıcı Adı: </strong> dansuk <br> <strong>Şifre: </strong> Dansuk123!*"
      }
    }
  },
  computed:{
    ...mapGetters(
      'user', {
        userProfile: 'userProfile'
      }
    )
  },
  components: {
      InnerNavigation: InnerNavigation,
      ExternalNavigation: ExternalNavigation,
      accaModal: accaModal
  },
  methods:{
    showAdditionalInformation(req){
      this.isInfoShown = true
      this.selectedText = this.additionalInformation[req]
    }
  }
}
</script>

<style scoped lang="scss">
  
  @import "../../styles/core/variables.scss";
  @import "../../styles/core/resets.scss";
  @import "../../styles/global/background.scss";
  @import "../../styles/global/helpers.scss";

</style>
